export const groupGrowTransition = function (
  expanded,
  stepCount,
  shouldSkip,
  duration
) {
  if (shouldSkip == null) {
    shouldSkip = false
  }
  if (duration == null) {
    duration = 300
  }
  const props = {
    animation: {
      height: expanded ? stepCount * 70 : 0
    },
    duration: shouldSkip ? 0 : duration,
    // apply styles immediately without transition if shouldSkip
    queue: shouldSkip ? false : undefined,
    begin(nodes) {
      const $node = nodes[0]
      return ($node.style.overflow = "hidden")
    },
    complete(nodes) {
      // Remove explicit height on completed expand so
      // group content can rezise (necessary for editing).
      if (expanded) {
        // Delayed since DOM flickers if explicit height is
        // removed before stepStaggerTransition is complete.
        return _.defer(function () {
          const $node = nodes[0]
          $node.style.overflow = "visible"
          return $node.style.removeProperty("height")
        })
      }
    }
  }
  return props
}

export const stepStaggerTransition = function (
  stepCount,
  shouldSkip,
  duration
) {
  if (shouldSkip == null) {
    shouldSkip = false
  }
  if (duration == null) {
    duration = 300
  }
  if (shouldSkip) {
    return
  }
  const props = {
    enter: {
      animation: "transition.expandIn",
      stagger: duration / stepCount + 1,
      duration,
      complete(nodes) {
        return Array.from(nodes).map(($node) =>
          // Remove transform property on completed transition
          // so step controls can z-index properly.
          $node.style.removeProperty("transform")
        )
      }
    },
    leave: {
      animation: "transition.expandOut",
      stagger: duration / stepCount,
      duration,
      backwards: true
    }
  }
  return props
}
